import {
  START_REQUEST,
  SUCCESS_REQUEST,
  FAIL_REQUEST,
  TOGGLE_SHOW_DETAILED,
  CLEAR_STATE,
} from './Actions';

export const initialState = {
  hasLoaded: false,
  SelectedPivot: null,
  SelectedFilters: [],
  ReportOptions: [],
  ReportData: {
    Current: {
      AssetValue: null,
      Indicators: [],
      ChartData: [],
      ChartDataDetailed: [],
      Labels: [],
      Series: [],
    },
    Recommended: {
      AssetValue: null,
      Indicators: [],
      ChartData: [],
      ChartDataDetailed: [],
      Labels: [],
      Series: [],
    },
  },
  errors: [],
  errorType: null,
  isDetailedShowing: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case START_REQUEST:
      return {
        ...state,
        hasLoaded: false,
      };
    case SUCCESS_REQUEST:
      return {
        ...state,
        ...action.payload,
        ReportData: {
          ...initialState.ReportData,
          Current: {
            ...initialState.ReportData.Current,
            ...action.payload.ReportData.Current,
          },
          Recommended: {
            ...initialState.ReportData.Recommended,
            ...action.payload.ReportData.Recommended || {},
          },
        },
        hasLoaded: true,
      };
    case FAIL_REQUEST:
      return {
        ...state,
        hasLoaded: true,
        errors: action.payload.errors,
        errorType: action.payload.errorType,
      };
    case TOGGLE_SHOW_DETAILED:
      return {
        ...state,
        isDetailedShowing: !state.isDetailedShowing,
      };
    case CLEAR_STATE:
      return initialState;
    default:
      return state;
  }
};
